import React from 'react';
import Helpers from './Helpers';

import './Button.css';

class Button extends React.Component {

	shouldComponentUpdate(nextProps, nextState) {
		let triggered = Helpers.update_trigger(this.props,nextProps);
		return triggered;
	}

	render() {
			let status = 0;
			if(this.props.index ===  this.props.active_index) {
				status = 1;
			}		
			return (
				<div 
					className = {"Button status-"+status}
					//className = {"Button "}
					onClick = 	{() => {
							this.props.button_handler(this.props.index) 
						}
					}
				>
				{this.props.name}
			</div> 
		)
	}
}

export default Button
